const registerState = {
    isEdited: {
        agentCode: false,
        company: false,
        email: false,
        password: false,
        tel: false,
        userkana: false,
        username: false,
        privacy: false,
        terms: false
    },
    params: {
        agentCode: '',
        company: '',
        email: '',
        password: '',
        projects: [],
        tel: '',
        userkana: '',
        username: '',
        privacy: false,
        terms: false
    },
    status: {
        provisional: false
    }
};

const register = {
    namespaced: true,
    state: registerState,
    mutations: {
        setEdited(state, payload) {
            Object.assign(state.isEdited, payload);
        },
        setParams(state, payload) {
            Object.assign(state.params, payload);
        },
        setStatus(state, payload) {
            Object.assign(state.status, payload);
        },
        reset(state) {
            Object.assign(state.isEdited, registerState.isEdited);
            Object.assign(state.params, registerState.params);
            Object.assign(state.status, registerState.status);
        }
    },
    actions: {
        setEdited({ commit }, response) {
            commit('setEdited', response);
        },
        setParams({ commit }, response) {
            commit('setParams', response);
        },
        setStatus({ commit }, response) {
            commit('setStatus', response);
        },
        reset({ commit }) {
            commit('reset');
        }
    }
};

export default register;
